"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListViewProductCard = ListViewProductCard;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fusePrice = require("@tvg/fuse-price");
var _fuseProductImage = _interopRequireDefault(require("@tvg/fuse-product-image"));
var _config = _interopRequireDefault(require("./config"));
var _styledListViewProductCard = require("./styled-list-view-product-card");
var _excluded = ["productUrl", "brand", "title", "titleTag", "image", "price", "saveForLater", "dataTestId", "className"],
  _excluded2 = ["isSaved", "saveCallback"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var useCallback = _react["default"].useCallback,
  useState = _react["default"].useState;
var propTypes = {
  productUrl: _propTypes["default"].string,
  brand: _propTypes["default"].string,
  title: _propTypes["default"].string,
  titleTag: _propTypes["default"].string,
  image: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    altText: _propTypes["default"].string,
    isAltReal: _propTypes["default"].bool
  }),
  price: _propTypes["default"].shape({
    current: _propTypes["default"].number,
    showCurrentPriceFrom: _propTypes["default"].bool,
    previous: _propTypes["default"].number,
    showPreviousPriceFrom: _propTypes["default"].bool,
    saving: _propTypes["default"].number,
    showSave: _propTypes["default"].bool,
    isEuro: _propTypes["default"].bool
  }),
  saveForLater: _propTypes["default"].shape({
    isSaved: _propTypes["default"].bool,
    saveCallback: _propTypes["default"].func
  }),
  dataTestId: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  productUrl: "#",
  brand: "",
  title: "",
  titleTag: "h3",
  image: {
    url: undefined,
    altText: undefined,
    isAltReal: false
  },
  price: {
    current: 0,
    showCurrentPriceFrom: false,
    previous: 0,
    showPreviousPriceFrom: false,
    saving: 0,
    showSave: true,
    isEuro: false
  },
  saveForLater: {
    saveCallback: null,
    isSaved: false
  },
  dataTestId: null,
  className: undefined
};
var isAltExists = function isAltExists(text) {
  return (typeof text === 'string' || text instanceof String) && text.length > 1;
};
function ListViewProductCard(_ref) {
  var productUrl = _ref.productUrl,
    brand = _ref.brand,
    title = _ref.title,
    titleTag = _ref.titleTag,
    image = _ref.image,
    price = _ref.price,
    saveForLater = _ref.saveForLater,
    dataTestId = _ref.dataTestId,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = saveForLater || {},
    isSaved = _ref2.isSaved,
    saveCallback = _ref2.saveCallback,
    restSFL = _objectWithoutProperties(_ref2, _excluded2);
  var _useState = useState(isSaved),
    _useState2 = _slicedToArray(_useState, 2),
    isSavePressed = _useState2[0],
    setSavePressed = _useState2[1];
  var imgAlt = !isAltExists(image === null || image === void 0 ? void 0 : image.altText) ? "Missing image for: ".concat(title) : image === null || image === void 0 ? void 0 : image.altText;
  var handleSaveForLater = useCallback(function (e, _, newState) {
    e.preventDefault();
    setSavePressed(newState);
    saveCallback(newState);
  }, [saveCallback]);
  return /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.CardContainer, _extends({
    className: className,
    "data-testid": dataTestId || 'fuse-list-view-product-card-data-testid'
  }, props), /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.StyledProductcard, {
    href: productUrl
  }, /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.ImageWrapper, null, /*#__PURE__*/_react["default"].createElement(_fuseProductImage["default"], {
    alt: imgAlt,
    src: image === null || image === void 0 ? void 0 : image.url,
    isAltReal: image === null || image === void 0 ? void 0 : image.isAltReal,
    sources: _config["default"]
  })), /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.ProductDetails, null, /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.BrandContainer, {
    type: "paragraph",
    size: "m1",
    tag: "span"
  }, brand), /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.TitleContainer, {
    type: "heading",
    size: "m1",
    tag: titleTag
  }, title), /*#__PURE__*/_react["default"].createElement(_fusePrice.Price, {
    headingTag: "h4",
    isEuro: price === null || price === void 0 ? void 0 : price.isEuro,
    prevPrice: price === null || price === void 0 ? void 0 : price.previous,
    price: price === null || price === void 0 ? void 0 : price.current,
    saving: price === null || price === void 0 ? void 0 : price.saving,
    showCurrentFrom: price === null || price === void 0 ? void 0 : price.showCurrentPriceFrom,
    showPreviousFrom: price === null || price === void 0 ? void 0 : price.showPreviousPriceFrom,
    showSave: price === null || price === void 0 ? void 0 : price.showSave,
    size: "xs",
    className: "fuse-list-view-product-card__price",
    "data-testid": "list-view-product-card__price"
  }))), saveCallback && typeof saveCallback === 'function' && /*#__PURE__*/_react["default"].createElement(_styledListViewProductCard.StyledSaveForLater, _extends({
    isSaved: isSaved,
    clickCallback: handleSaveForLater,
    showLabel: false,
    "aria-pressed": isSavePressed,
    saveLabel: "Save for later ".concat(brand, " ").concat(title),
    savedLabel: "Saved ".concat(brand, " ").concat(title),
    iconSize: "small"
  }, restSFL)));
}
ListViewProductCard.propTypes = propTypes;
ListViewProductCard.defaultProps = defaultProps;
var _default = exports["default"] = ListViewProductCard;